import { forwardRef } from 'react';
import type { TextareaHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, invalid = false, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      className={cn(
        'w-full px-3 py-2 rounded-xl text-base',
        'bg-tg-section-bg border resize-none',
        'transition-colors duration-150',
        'placeholder:text-tg-hint placeholder:opacity-70',
        'focus:outline-none focus:ring-2 focus:ring-brand/40 focus:border-brand',
        invalid
          ? 'border-destructive/60 focus:ring-destructive/40 focus:border-destructive'
          : 'border-tg-hint/30',
        className,
      )}
      {...rest}
    />
  );
});
